module.exports = __webpack_public_path__ + "static/media/webdesign-services-img21.315b4a0a.jpg";